import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chart.js/auto';
import { Box } from '@mui/material';
import { Props } from './types';
import NoDataComponent from '../NoDataAvailable';

const PieChart = ({ pieData, title, unit, hideLabel }: Props) => (
  <Box
    height={'100%'}
    width={'100%'}
    display={'flex'}
    justifyContent={'center'}
    alignItems={'center'}
  >
    {pieData.datasets.length == 0 ? (
      <NoDataComponent title={title} />
    ) : (
      <Pie
        data={pieData}
        plugins={[ChartDataLabels]}
        options={{
          responsive: true,
          plugins: {
            datalabels: {
              color: 'white',
              font: {
                size: 14,
                weight: 'bold',
              },
              formatter: (value, context) => {
                const data = context.chart.data.datasets[0].data as number[];
                const total = data.reduce((acc, num) => acc + num, 0);

                const percentage = ((value / total) * 100).toFixed(1);
                const labels = context.chart.data.labels as string[];
                const label = labels?.[context.dataIndex] || '';
                const unitLabel = unit === 'Percentage' ? `${percentage}%` : `${value}`;

                return value > 0
                  ? `${unitLabel} ${hideLabel ? '' : label.charAt(0).toUpperCase()}`
                  : null;
              },
            },
            legend: {
              labels: {
                color: 'black',
                font: {
                  size: 14,
                  weight: 'bold',
                },
              },
            },
            title: {
              display: true,
              text: `${title}`,
              color: '#2e6acf',
              font: {
                size: 20,
                weight: 'bold',
              },
            },
          },
        }}
      />
    )}
  </Box>
);

export default PieChart;
